import { X, PlusCircle } from "lucide-react";

/**
 * Modal that lets PCWM create a brand-new placement (project) inline while
 * they're editing / bulk-assigning bookings.  Extracted from `ProgramBooking.jsx`
 * (iter 57.43).  The parent seeds destination + city from the booking, so
 * this component stays fully controlled via the `newProj` state object.
 */
export default function NewProjectModal({ newProj, setNewProj, onSave }) {
  if (!newProj) return null;
  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setNewProj(null)}>
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-testid="pb-newproj-modal">
        <div className="p-4 border-b border-[color:var(--aii-border)] flex items-start justify-between gap-2">
          <div>
            <h3 className="font-display text-lg font-semibold">New placement / project</h3>
            <p className="text-xs text-[color:var(--aii-muted)]">Destination + city are auto-filled from the booking. Edit them if the placement lives elsewhere.</p>
          </div>
          <button onClick={() => setNewProj(null)} className="text-[color:var(--aii-muted)] hover:text-red-600 p-1"><X size={16}/></button>
        </div>
        <div className="p-4 space-y-3">
          <label className="block text-[11px] uppercase tracking-widest text-[color:var(--aii-muted)] font-semibold">Placement name
            <input data-testid="pb-newproj-name" autoFocus value={newProj.name}
                   onChange={e => setNewProj(p => ({ ...p, name: e.target.value }))}
                   placeholder="e.g. Apex Hospital"
                   className="input-aii mt-1"/>
          </label>
          <div className="grid grid-cols-2 gap-2">
            <label className="block text-[11px] uppercase tracking-widest text-[color:var(--aii-muted)] font-semibold">Destination
              <input data-testid="pb-newproj-dest" value={newProj.destination}
                     onChange={e => setNewProj(p => ({ ...p, destination: e.target.value }))}
                     className="input-aii mt-1"/>
            </label>
            <label className="block text-[11px] uppercase tracking-widest text-[color:var(--aii-muted)] font-semibold">City
              <input data-testid="pb-newproj-city" value={newProj.city}
                     onChange={e => setNewProj(p => ({ ...p, city: e.target.value }))}
                     className="input-aii mt-1"/>
            </label>
          </div>
        </div>
        <div className="p-3 border-t border-[color:var(--aii-border)] flex items-center justify-end gap-2">
          <button onClick={() => setNewProj(null)} className="px-3 py-2 text-sm border border-[color:var(--aii-border)] rounded-md hover:bg-slate-50">Cancel</button>
          <button data-testid="pb-newproj-save" onClick={onSave}
                  className="px-4 py-2 text-sm bg-brand text-white font-semibold rounded-md hover:bg-brand-dark flex items-center gap-1">
            <PlusCircle size={13}/> Save placement
          </button>
        </div>
      </div>
    </div>
  );
}
